import React from 'react';

import { SxProps } from '@mui/material/styles';

import { StudentActivityAnswer } from '../../types';

import ActivityBaseMessage from '../ActivityBaseMessage';

export interface ActivityAnswerProps {
  sx?: SxProps;
  title?: React.ReactNode;

  answer?: StudentActivityAnswer;
  loading?: boolean;

  onDeleteAnswer?: () => void;
}

const ActivityAnswer = (props: ActivityAnswerProps) => {
  const { sx, title, loading = false, onDeleteAnswer, answer } = props;

  return (
    <ActivityBaseMessage
      mode="student"
      sx={sx}
      title={title}
      text={answer?.text}
      file={answer?.file}
      date={answer?.createdAt}
      loading={loading}
      onDelete={onDeleteAnswer}
      deleteAlertMessage="¿Seguro de que deses eliminar la respuesta?"
    />
  );
};

export default ActivityAnswer;
